import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseServiceV2 } from '@servicesv2';
import { ConsultaPaginadaViewModel } from '../../model/model.api';
import { ClassificacoesFiscaisIBPTDetalhesViewModel, ConsultaClassificacoesFiscaisIBPTViewModel } from '../../models/atualizacao-ibpt/AtualizacaoIBPTViewModel';
import { AliquotaIntraEstadualViewModel } from '../../model/AliquotasInterestaduais';

@Injectable()
export class ClassificacoesFiscaisServiceV2 extends BaseServiceV2 {

  constructor(http: HttpClient) {
    super('ClassificacoesFiscais', http);
  }

  consultaPaginadaClassificacoesFiscaisIBPT(payload: ConsultaClassificacoesFiscaisIBPTViewModel)  {
    return this.postPaginatedAsPromise<ConsultaClassificacoesFiscaisIBPTViewModel, ConsultaPaginadaViewModel<ClassificacoesFiscaisIBPTDetalhesViewModel>>(payload);
  }

  getAliquotaIntraEstadual(ncm: number, destinoEstadoId: number) {
    return this.getAsPromise<AliquotaIntraEstadualViewModel[]>(`getAliquotasIntraEstaduais/${ncm}?destinoEstadoId=${destinoEstadoId}`);
  }

}
